import { AuthGuard } from './guards/auth.guard';
import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomePageModule)
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'add-patient',
    loadChildren: () => import('./pages/add-patient/add-patient.module').then(m => m.AddPatientPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'patient-list',
    loadChildren: () => import('./pages/patient-list/patient-list.module').then(m => m.PatientListPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'patient-detail/:patientId',
    loadChildren: () => import('./pages/patient-detail/patient-detail.module').then(m => m.PatientDetailPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'print-recipe',
    loadChildren: () => import('./pages/print-recipe/print-recipe.module').then(m => m.PrintRecipePageModule),
    canActivate: [AuthGuard]
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
